const userInitialState = {
    isLoggedIn: false,
    userDetails: {},
    supplierDetails: {},
    token: "",
    isLoading: false,
    language: 'en',
    tempEmail: "",
    otpSendTime: "",
    isEmailVerified: false,
    is2faEnabled: false,
    is2faVerified: false,
    isDarkMode:false,
    availablity:null,
    permissions:{},

};
export default userInitialState;